<template>
	<div class="c-billing-faqs">
		<Accordion>
			<template v-slot:title>
				<h4>I'm unable to pay for a subscription</h4>
			</template>

			<template v-slot:body>
				<div>
					<p>
						Sometimes, payments fail even if the card is valid. While this is
						largely out of our control and in Stripe's hands, there are a few
						things you can do about this:
					</p>
					<ul>
						<li>
							Make sure you aren't using a VPN. For best results, connect to
							your local wifi and pay via the Chrome browser.
						</li>
						<li>
							American express gets declined a lot. If this happens, use another
							card.
						</li>
					</ul>
					<p>
						If your card is getting declined consistently, contact customer
						support and we'll help you sort it out.
					</p>
				</div>
			</template>
		</Accordion>

		<Accordion>
			<template v-slot:title>
				<h4>
					If I upgrade/downgrade my subscription will my payment get prorated?
				</h4>
			</template>

			<template v-slot:body>
				<div>
					<p>
						Yes, we automatically prorate your payment. Here’s how it works:
					</p>
					<ul>
						<li>
							Example 1 (Monthly):<br />
							You pay $39 for the monthly Basic plan, then upgrade on the same
							day to the $69 monthly Plus plan. You’ll only pay the difference
							($30) right away, and from next month your billing will be
							$69/month.
						</li>
						<li>
							Example 2 (Annual):<br />
							You pay $312 for the annual Basic plan (12 months). After 4
							months, you switch to the monthly Basic plan. Since you’ve already
							paid for 8 months upfront, you won’t be charged again until those
							months are used up.
						</li>
					</ul>
				</div>
			</template>
		</Accordion>

		<Accordion>
			<template v-slot:title>
				<h4>How do API credits work?</h4>
			</template>

			<template v-slot:body>
				<div>
					<ul>
						<li>Saving a new ad from a URL through MCP costs 1 API credit.</li>
						<li>Saving the same ad again or adding it to boards is free.</li>
						<li>Trial includes 10 API credits. Paid plans refresh credits every month.</li>
						<li>
							No rollover. Unused credits don’t carry over - each month you
							start fresh.
						</li>
						<li>On annual billing, credits are still allocated monthly.</li>
						<li>
							Upgrading or downgrading your plan resets your credits to the new
							plan’s amount.
						</li>
					</ul>
				</div>
			</template>
		</Accordion>

		<Accordion>
			<template v-slot:title>
				<h4>Why did my monthly payment fail?</h4>
			</template>

			<template v-slot:body>
				<div>
					<p>
						At the end of your billing cycle, Swipekit will try to bill your
						card.
					</p>
					<p>
						If your card gets declined, Swipekit will try multiple attempts over
						the next few days.
					</p>
					<p>
						If your card still isn't charged, Swipekit will deactivate your
						account and you will need to re-enter your card details in order to
						use Swipekit.
					</p>
					<p>
						Don't worry, we won't delete your data when your account is
						deactivated.
					</p>
				</div>
			</template>
		</Accordion>

		<Accordion>
			<template v-slot:title>
				<h4>If my payment fails, will my data be lost?</h4>
			</template>

			<template v-slot:body>
				<div>
					<p>No, your data isn't lost.</p>
					<p>
						We keep your data around for at least 3 months - unless you
						explicitely delete your workspace.
					</p>
				</div>
			</template>
		</Accordion>
	</div>
</template>

<script>
import Accordion from '@swipekit/components/utils/accordion';

export default {
	components: {
		Accordion,
	},
};
</script>

<style lang="scss">
.c-billing-faqs {
	margin-bottom: 2rem;

	h4 {
		font-weight: 450;
		text-transform: initial;
		letter-spacing: 0;
	}

	.c-accordion {
		&__body {
			> div {
				padding: var(--margin-lg) var(--margin);
				opacity: 0.9;
			}
		}
	}
}
</style>
